import useSWR from "swr";
import { AspBrandsEnum, BrandsEnum } from "../typings/enums";
import { buildQueryParams, isInstanceOfEnum } from "../libs/object";
import { ApiResponse } from "../typings/interfaces";

const useSearchProducts = <T>(
  brand: BrandsEnum | AspBrandsEnum | string,
  search: string,
  perPage?: number
) => {
  let url = null;
  if (brand && search.length >= 3) {
    url = `/price-list/${brand}/?${buildQueryParams({
      search,
      perPage,
    })}`;
  }

  const { data, isLoading, error, mutate, isValidating } =
    useSWR<ApiResponse<T[]>>(url);

  return {
    items: data?.data ?? [],
    isValidating,
    isLoading,
    error: (!data?.data && data?.error) || error || null,
    mutate,
  };
};

export default useSearchProducts;
